import { render, staticRenderFns } from "./FrotaHelperList.vue?vue&type=template&id=6aefaeb4"
import script from "./FrotaHelperList.vue?vue&type=script&lang=js"
export * from "./FrotaHelperList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports